module.exports = __webpack_public_path__ + "img/studyicon.1b6b04e7.png";